import { WireHomeQuotePayload } from 'scenes/home/api/quote/types';
import {
  Excess,
  InsuranceOptionBase,
  LabelValueType,
  PaymentFrequency,
  YesNoAnswer,
  Campaign,
  CoverType,
} from 'scenes/common/types';

export enum HomeCoverSubSection {
  BuildingExcess = 'Building excess',
  ContentsExcess = 'Contents excess',
  PortableContents = 'Portable contents',
  OptionalExtras = 'Optional extras',
  SpecifiedContents = 'Specified contents',
  UnspecifiedPortables = 'Unspecified portables',
}

export enum ExcessType {
  Unspecified = '',
  Standard = 'Standard',
  Additional = 'Additional',
}

export enum OptionalExtra {
  Unspecified = '',
  AccidentalDamage = 'AccidentalDamage',
  FusionContent = 'FusionContent',
  FusionBuilding = 'FusionBuilding',
  GeneralPortables = 'GeneralPortables',
}

export type InsuranceOption = InsuranceOptionBase & {
  coverType: CoverType;
};

export type VehicleModification = {
  name: string;
  description: string;
};

export type QuoteUserSelections = {
  buildingExcess: Excess;
  contentsExcess: Excess;
};

export type HomeQuoteDetails = {
  payload: WireHomeQuotePayload;
  insuranceOptions: InsuranceOption[];
  buildingExcesses: Excess[];
  contentsExcesses: Excess[];
  portablesExcesses: Excess[];
  unspecifiedPortableLimitRanges: LabelValueType[];
  userSelections: QuoteUserSelections;
  saveQuoteEmailAddress?: string;
  recalculatedInstalments?: {
    firstInstalment: string;
    monthlyInstalment: string;
  };
  receiptNumber?: string;
  campaigns: Campaign[];
};

export interface CoverOptionsData {
  preselectedPaymentFrequency: PaymentFrequency;
  selectedExtras: string[];
  specifiedContentsAnswer: YesNoAnswer;
  specifiedContents: SpecifiedContent[];
  specifiedContent: SpecifiedContent;
  unspecifiedPortableContents: YesNoAnswer;
  unspecifiedPortableContentsLimit: string;
  isPortableContentsExtraSelected: boolean;
}

export enum SpecifiedContentCover {
  Home = 'Home only',
  PortableContents = 'Portable contents',
  Unspecified = '',
}

export type SpecifiedContent = {
  id: number;
  category: string;
  description: string;
  itemValue: string;
  cover: SpecifiedContentCover;
};
